import _ from 'lodash';
import * as React from 'react';
import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { isCsr } from '../../../common/utils';
import { useAdviserDetails } from '../../../hooks/AppStateHook';
import ExternalLinksListItem from './ExternalLinksListItem/ExternalLinksListItem';
import testIds from './ExternalLinksList.elements';

const NavLinksContainer = styled.nav`
	border: 0;
	display: flex;
	flex: 1;
	padding: 0;
`;

const UlBorder = styled.ul`
	display: flex;
	flex: 1;
	flex-direction: column;
	margin-bottom: 0;
	margin-top: 0;
	padding: 0;
`;

interface Props {
	links: Link[];
}

const ExternalLinksList: React.FunctionComponent<Props> = props => {
	const { roles } = useAdviserDetails();
	return (
		<NavLinksContainer>
			<UlBorder data-id={testIds.externalListActionComponent}>
				{_.map(props.links, (item: Link, index: number) => (
					<ExternalLinksListItem
						title={item.title}
						url={item.url}
						key={_.kebabCase(item.title)}
						color={index === 0 ? palette.mlcText : undefined}
						iconColor={index === 0 ? palette.mlcText : undefined}
						disabled={(item.disabledForCsr || false) && isCsr(roles)}
					>
						<div dangerouslySetInnerHTML={{ __html: item.title }} />
					</ExternalLinksListItem>
				))}
			</UlBorder>
		</NavLinksContainer>
	);
};

export default ExternalLinksList;

export interface Link {
	url: string;
	title: string;
	disabledForCsr?: boolean;
}
